import { render, staticRenderFns } from "./RecognitionsView.vue?vue&type=template&id=33ceb02c"
import script from "./RecognitionsView.vue?vue&type=script&lang=js"
export * from "./RecognitionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports